import {
  FETCH_BEACON_COMPLETE_FAILURE,
  FETCH_BEACON_COMPLETE_REQUEST,
  FETCH_BEACON_COMPLETE_SUCCESS,
  FETCH_BEACON_FAILURE,
  FETCH_BEACON_REQUEST,
  FETCH_BEACON_SUCCESS,
  FETCH_BEACONS_FAILURE,
  FETCH_BEACONS_REQUEST,
  FETCH_BEACONS_SUCCESS,
  SAVE_BEACON_FAILURE,
  SAVE_BEACON_REQUEST,
  SAVE_BEACON_SUCCESS,
} from '../../reducers/types';
import {
  getBeaconByIdService,
  getBeaconCompleteByIdService,
  getBeaconsService,
  saveBeaconService,
} from '../../services/appCmsServices/BeaconService';
import { beaconsPaginationParams } from '../../pages/appCms/beacon/Constants';

export const getBeaconsAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_BEACONS_REQUEST,
      });
      // const response = await dispatch(getBeaconsService({ ...beaconsPaginationParams }))
      const response = await dispatch(getBeaconsService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_BEACONS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_BEACONS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_BEACONS_FAILURE,
      });
    }
  };
};

export const saveBeaconAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_BEACON_REQUEST,
      });
      const response = await dispatch(saveBeaconService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_BEACON_SUCCESS,
          payload: response.data,
        });
        dispatch(getBeaconsAction({ ...beaconsPaginationParams }));
      } else {
        dispatch({
          type: SAVE_BEACON_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_BEACON_FAILURE,
      });
    }
  };
};

export const getBeaconByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_BEACON_REQUEST,
      });
      const response = await dispatch(getBeaconByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_BEACON_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_BEACON_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_BEACON_FAILURE,
      });
    }
  };
};

export const getBeaconCompleteByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_BEACON_COMPLETE_REQUEST,
      });
      const response = await dispatch(getBeaconCompleteByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_BEACON_COMPLETE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_BEACON_COMPLETE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_BEACON_COMPLETE_FAILURE,
      });
    }
  };
};

// export const getBeaconImageByIdAction = id => {
//   return async dispatch => {
//     try {
//       dispatch({
//         type: FETCH_BEACON_IMAGE_REQUEST,
//       });
//       const response = await dispatch(getBeaconImageByIdService(id));
//       if (response.status === 200) {
//         dispatch({
//           type: FETCH_BEACON_IMAGE_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_BEACON_IMAGE_FAILURE,
//         });
//         throw Error;
//       }
//     } catch (error) {
//       // eslint-disable-next-line no-console
//       console.error(error);
//       dispatch({
//         type: FETCH_BEACON_IMAGE_FAILURE,
//       });
//     }
//   };
// };

// export const getSimpleBeaconListAction = (idList, all) => {
//   return async dispatch => {
//     try {
//       dispatch({
//         type: FETCH_SIMPLE_BEACON_LIST_PDF_REQUEST,
//       });
//       const response = await dispatch(getSimpleBeaconListService(idList, all));
//       if (response.status === 200) {
//         dispatch({
//           type: FETCH_SIMPLE_BEACON_LIST_PDF_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_SIMPLE_BEACON_LIST_PDF_FAILURE,
//         });
//         throw Error;
//       }
//     } catch (error) {
//       // eslint-disable-next-line no-console
//       console.error(error);
//       dispatch({
//         type: FETCH_SIMPLE_BEACON_LIST_PDF_FAILURE,
//       });
//     }
//   };
// };

// export const getCustomBeaconListAction = idList => {
//   return async dispatch => {
//     try {
//       dispatch({
//         type: FETCH_CUSTOM_BEACON_LIST_PDF_REQUEST,
//       });
//       const response = await dispatch(getCustomBeaconListService(idList));
//       if (response.status === 200) {
//         dispatch({
//           type: FETCH_CUSTOM_BEACON_LIST_PDF_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_CUSTOM_BEACON_LIST_PDF_FAILURE,
//         });
//         throw Error;
//       }
//     } catch (error) {
//       // eslint-disable-next-line no-console
//       console.error(error);
//       dispatch({
//         type: FETCH_CUSTOM_BEACON_LIST_PDF_FAILURE,
//       });
//     }
//   };
// };
